import script from "./TabBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBox.vue?vue&type=script&setup=true&lang=js"

import "./TabBox.vue?vue&type=style&index=0&id=40cf886d&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40cf886d"]])

export default __exports__